module.exports = __webpack_public_path__ + "img/left4.f7be83fa.png";